import { applyLightLoginTheme } from "./lightLoginTheme";

applyLightLoginTheme();
